import { render, staticRenderFns } from "./CaseUmcc.vue?vue&type=template&id=383dfbe2&lang=pug"
import script from "./CaseUmcc.vue?vue&type=script&lang=js"
export * from "./CaseUmcc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports